import { createBrowserHistory } from "history";

// Single shared history instance used by both react-router's <Router> (in
// src/index.js) and imperative URL updates (src/router/UrlQueries.js). Sharing
// one instance keeps browser back/forward and programmatic pushes in sync
// without routing state living in redux.
export default createBrowserHistory();
